import { OrderItem as OrderItemModel, OrderStaff } from '@spike/order-model';
import { FunctionComponent } from 'react';
import MembershipIcon from '../Memberships/MembershipIcon';
import styles from './OrderItemData.module.css';
import PriceItem from './PriceItem';

export interface OrderDataProps {
    type: string;
    orderItem: OrderItemModel;
    staff?: OrderStaff;
    className?: string;
}

export const OrderData: FunctionComponent<OrderDataProps> = props => {
    const hasMembershipApplied = props.orderItem.redeem !== undefined;

    const firstLine = (
        <>
            <span className={styles.description}>{props.orderItem.description}</span>
            {`(${props.orderItem.quantity}) · `}
        </>
    );
    const price = (
        <PriceItem
            originalPrice={(hasMembershipApplied
                ? Number(props.orderItem.originalPrice)
                : Number(props.orderItem.amount) * props.orderItem.quantity
            ).toFixed(2)}
            price={props.orderItem.total ?? '0.00'}
            className={styles.price}
        />
    );

    const staffMember = props.staff ? props.staff.firstName : 'Unassigned';
    const secondLine = `${props.type} · ${staffMember}`;

    return (
        <>
            <div className={styles.firstLineContainer}>
                {hasMembershipApplied && <MembershipIcon className={styles.membershipIcon} />}
                <span className={styles.firstLine}>
                    {firstLine}
                    {price}
                </span>
            </div>
            <span className={styles.secondLine}>{secondLine}</span>
        </>
    );
};

export default OrderData;
